/**
 * 页面跳转行为收集
 */

import { Type, PvOptions } from './types'
import { globalOptions } from './option'
import { report } from './report'
import { on } from '../utils'

enum EventType {
  LOAD = 'LOAD',
  BEFORE_UNLOAD = 'BEFORE_UNLOAD',
  HASH_CHANGE = 'HASH_CHANGE',
  POP_STATE = 'POP_STATE',
  PUSH_STATE = 'PUSH_STATE',
  REPLACE_STATE = 'REPLACE_STATE',
  PERIOD_PV = 'PERIOD_PV'
}

let options: PvOptions

function initPv() {
  options = globalOptions.pv as PvOptions
  if (options.route) {
    listenLoad()
    listenHash()
    listenHistory()
  }
  if (options.interval > 0) {
    listenPageView()
  }
}

function listenLoad() {
  reportPV({ eventType: EventType.LOAD })
  on(window, 'load', () => {
    reportPV({ eventType: EventType.LOAD })
  }, false)
  on(window, 'beforeunload', (evt: BeforeUnloadEvent) => {
    console.log('beforeunload', evt)
    reportPV({ eventType: EventType.BEFORE_UNLOAD })
  }, false)
}

function listenHash() {
  on(window, 'hashchange', (evt: HashChangeEvent) => {
    console.log('hashchange', evt)
    reportPV({ eventType: EventType.HASH_CHANGE, oldUrl: evt.oldURL, newUrl: evt.newURL })
  }, false)
}

function listenHistory() {
  if (!window.history.pushState) {
    return
  }
  on(window, 'popstate', (evt: PopStateEvent) => {
    console.log('popstate', evt);
    reportPV({ eventType: EventType.POP_STATE, state: evt.state })
  })
  const originPushState = window.history.pushState
  window.history.pushState = function (...args: Parameters<History["pushState"]>) {
    console.log('pushState', ...args);
    reportPV({ eventType: EventType.PUSH_STATE, data: args[0] })
    originPushState.call(this, ...args)
  }
  const originReplaceState = window.history.replaceState
  window.history.replaceState = function (...args: Parameters<History["replaceState"]>) {
    console.log('replaceState', ...args);
    reportPV({ eventType: EventType.REPLACE_STATE, data: args[0] })
    originReplaceState.call(this, ...args)
  }
}

function listenPageView() {
  setInterval(() => {
    reportPV({ eventType: EventType.PERIOD_PV })
  }, options.interval)
}

function reportPV(data?: Record<string, any>) {
  setTimeout(() => {
    report(Type.PV, {
      ...data,
      referrer: document.referrer
    })
  }, 17)
}

export {
  initPv
}
